export const healthProductEndpoints = (builder) => ({
    getHealthProducts: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                searchValue,
                sortField,
                sortOrder,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (searchValue) params.searchValue = searchValue;
            if (sortField) params.sortField = sortField;
            if (sortOrder) params.sortOrder = sortOrder;

            return {
                url: '/HealthProduct/HealthProductMaster',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['HealthProduct'],
    }),

    getHealthProductById: builder.query({
        query: (id) => `/HealthProduct/get-health-product/${id}`,
        providesTags: (result, error, id) => [{ type: 'HealthProduct', id }],
    }),

    saveHealthProduct: builder.mutation({
        query: (data) => ({
            url: '/HealthProduct/SaveHealthProductMaster',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['HealthProduct'],
    }),

    updateHealthProduct: builder.mutation({
        query: ({ id, data }) => ({
            url: `/HealthProduct/SaveHealthProductMaster`,
            method: 'POST',
            body: data,
        }),
        invalidatesTags: (result, error, { id }) => [
            { type: 'HealthProduct', id },
            'HealthProduct'
        ],
    }),

    deleteHealthProduct: builder.mutation({
        query: (id) => ({
            url: `/HealthProduct/delete-health-product/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['HealthProduct'],
    }),

    bulkDeleteHealthProduct: builder.mutation({
        query: (ids) => ({
            url: "/HealthProduct/bulk-delete-health-product",
            method: "POST",
            body: { ids },
        }),
        invalidatesTags: ['HealthProduct'],
    }),
});
